/**
 * Page side of a notification click (see `notificationclick` in public/sw.js).
 *
 * When the app is already open, the service worker asks the page to navigate
 * instead of calling client.navigate(), which does nothing in a backgrounded
 * iOS home-screen app. The page acks over the message port so the worker knows
 * not to fall back. Only same-origin URLs are followed.
 */
export function listenForOpenUrl(): () => void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return () => {};
  }
  const sw = navigator.serviceWorker;

  const onMessage = (event: MessageEvent) => {
    const data = event.data as { type?: string; url?: unknown } | null;
    if (data?.type !== "open-url" || typeof data.url !== "string") return;

    let url: URL;
    try {
      url = new URL(data.url, window.location.origin);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin) return;

    event.ports[0]?.postMessage("ok");
    window.location.assign(url.href);
  };

  sw.addEventListener("message", onMessage);
  return () => sw.removeEventListener("message", onMessage);
}
